import React from "react";
import ConfirmationDialog from "components/ConfirmationDialog";

const ConfirmDeleteDialog = props => {
  const { open, server, onOk, onCancel } = props;

  return (
    <ConfirmationDialog
      onCancel={onCancel}
      onConfirm={() => onOk(server)}
      title="Delete Patron API Server"
      confirmButtonText="Yes"
      message={`Are you sure you want to delete this Patron API Server with ID : ${server.patronApiServerId}?`}
      visible={open}
    />
  );
};

export default ConfirmDeleteDialog;
